import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NdcRegistrationPage } from 'src/app/model/page/ndc-registration-page';
import { NoteSection } from 'src/app/model/section/note-section';
import { ContentfulService } from 'src/app/service/contentful.service';
import { GroupValidator } from 'src/app/validator/group-validator';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-registration-page',
  templateUrl: './ndc-registration-page.component.html',
  styleUrls: ['./ndc-registration-page.component.scss']
})
export class NdcRegistrationPageComponent implements OnInit {
  pageName = 'British Airways NDC Registrations';

  ndcRegistrationPage: NdcRegistrationPage = {} as NdcRegistrationPage;
  ndcRegistrationData: any = [];
  salesHubCategory: any = [];

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'ndc-registrations') {
        this.ndcRegistrationData.htmlTitle = title.htmlTitle;
      }
    });
    this.ndcRegistrationPage.sections = [];
    this.ndcRegistrationPage.ndcRegistrationCards = [];
    this.ndcRegistrationPage.ndcRegistrationSubCards = [];
    this.ndcRegistrationPage.noteSections = [];
    this.ndcRegistrationPage.sectionAboveNote = [];
    this.ndcRegistrationPage.sectionBelowNote = [];
    this.ndcRegistrationData.sectionInCard = [];
    this.ndcRegistrationPage.salesHubCategory = [];
    this.ndcRegistrationPage.cardNoteSections = [];

    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentWithEntries(query).then((ndcRegistrationPageEntries) => {
      this.mapBanner(ndcRegistrationPageEntries);
      this.mapSections(ndcRegistrationPageEntries);
      this.mapNoteSections(ndcRegistrationPageEntries);
      this.mapCards(ndcRegistrationPageEntries, query['fields.title']);
    });
    this.contentfulService.getPageContentWithItems(query).then((ndcRegistrationPageEntries) => {
      ndcRegistrationPageEntries.forEach((entry: any) => {
        this.ndcRegistrationPage.htmlTitle = entry.fields.htmlTitle;
      });
    });
  }

  private mapBanner(ndcRegistrationPageEntries: Entry<any>[]) {
    ndcRegistrationPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapSections(ndcRegistrationPageEntries: Entry<any>[]) {
    ndcRegistrationPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.ndcRegistrationPage.sectionAboveNote = this.ndcRegistrationPage.sections.filter((section) => GroupValidator.isAboveNoteSection(section.group));
    this.ndcRegistrationPage.sectionAboveNote.sort((a, b) => a.order - b.order);

    this.ndcRegistrationPage.sectionBelowNote = this.ndcRegistrationPage.sections.filter((section) => GroupValidator.isBelowNoteSection(section.group));
    this.ndcRegistrationPage.sectionBelowNote.sort((a, b) => a.order - b.order);
  }

  private mapNoteSections(ndcRegistrationPageEntries: Entry<any>[]) {
    ndcRegistrationPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        switch (entry.fields['group']) {
          case this.pageName:
            this.mapEntryToNoteSection(entry);
            break;
          case 'card-note':
            this.mapCardNoteSections(entry);
            break;
          default:
            console.error('New group Found - ' + entry.fields['title']);
            break;
        }
      });

    this.ndcRegistrationPage.noteSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToNoteSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();
    this.ndcRegistrationPage.noteSections.push({
      fullTitle: givenTitle,
      title: pageTitle,
      iconClass: entry.fields['iconClass'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      noteClass: entry.fields['noteClass'] as string
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.ndcRegistrationPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url as string
    };
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();
    this.ndcRegistrationPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapCards(ndcRegistrationPageEntries: Entry<any>[], pageTitle: string) {
    ndcRegistrationPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .filter((entry) => entry.fields['headImage'])
      .forEach((entry) => {
        this.mapEntryToNdcRegistrationCards(entry, ndcRegistrationPageEntries);
      });

    ndcRegistrationPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .filter((entry) => entry.fields)
      .forEach((entry) => {
        this.mapEntryToNdcRegistrationSubCards(entry);
      });
    this.ndcRegistrationPage.ndcRegistrationCards.sort((a, b) => a.order - b.order);
  }

  private mapEntryToNdcRegistrationCards(cardEntry: Entry<any>, ndcRegistrationPageEntries: Entry<any>[]) {
    const noteSections: NoteSection[] = [];
    ndcRegistrationPageEntries
      .filter((noteEntry) => ModelValidator.isNote(noteEntry) && noteEntry.fields['group'] === cardEntry.fields['group'])
      .forEach((noteEntry) => {
        let givenTitle: any = noteEntry.fields['title'] as string;
        let pageTitle = givenTitle.split('#').pop();

        noteSections.push({
          fullTitle: noteEntry.fields['title'] as string,
          title: pageTitle,
          iconClass: noteEntry.fields['iconClass'] as string,
          body: noteEntry.fields['body'] as string,
          group: noteEntry.fields['group'] as string,
          order: noteEntry.fields['order'] as number,
          noteClass: noteEntry.fields['noteClass'] as string
        });
      });

    noteSections.sort((a, b) => a.order - b.order);

    let headerImage: any = cardEntry.fields['headImage'];
    let pageBody: any = cardEntry.fields['body'] as string;

    this.ndcRegistrationPage.ndcRegistrationCards.push({
      title: cardEntry.fields['title'] as string,
      order: cardEntry.fields['order'] as number,
      headImage: headerImage.fields?.file?.url,
      body: pageBody.content[0].content[0].value,
      buttonText: cardEntry.fields['buttonText'] as string,
      buttonUrl: cardEntry.fields['buttonUrl'] as string,
      noteSections: this.ndcRegistrationPage.cardNoteSections.filter((cardNoteSections) => cardNoteSections.category === cardEntry.fields['title'])
    });
  }

  private mapEntryToNdcRegistrationSubCards(entry: Entry<any>) {
    this.ndcRegistrationPage.ndcRegistrationSubCards.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      category: entry.fields['category'] as string,
      headImage: '',
      body: '',
      buttonText: entry.fields['buttonText'] as string,
      buttonUrl: entry.fields['buttonUrl'] as string
    });
    this.ndcRegistrationPage.ndcRegistrationSubCards.sort((a, b) => a.order - b.order);
    this.ndcRegistrationPage.salesHubCategory = this.ndcRegistrationPage.ndcRegistrationSubCards.filter((card) => card.category === 'saleshub');
  }

  private mapCardNoteSections(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();
    this.ndcRegistrationPage.cardNoteSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      category: entry.fields['category'] as string,
      order: entry.fields['order'] as number,
      fullTitle: givenTitle,
      iconClass: entry.fields['iconClass'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
    this.ndcRegistrationPage.cardNoteSections.sort((a, b) => a.order - b.order);
  }
}
